import { useTranslationWithPrefix } from '@hotjar/translations';
import type { CountryCode } from '@hotjar/country-lib';
import { Alert, Card, tokens } from '@hotjar/hotsauce';
import type { InterpreterFrom } from 'xstate';
import { useActor } from '@xstate/react';
import styled from '@emotion/styled';
import { Heading } from '../EditOrderContainer.styles';
import type { VaultedResponse } from '../../../../features/credit-card/CreditCardDetails';
import { CreditCardDetails } from '../../../../features/credit-card/CreditCardDetails';
import { PAGE } from '~/subscription-management/utils/tracking';
import type { paymentDetailsMachine } from '~/subscription-management/checkout/state-machine/child-machines/payment-details.machine';

interface Props {
  countryCode: CountryCode | undefined;
  onSuccess(response: VaultedResponse): void;
  accountId: number;
  paymentDetailsService: InterpreterFrom<typeof paymentDetailsMachine>;
}

const S = {
  Alert: styled(Alert)`
    margin-bottom: ${tokens.spacer.x2};
  `,
};

export function PaymentDetails({
  countryCode,
  onSuccess,
  accountId,
  paymentDetailsService,
}: Props): JSX.Element {
  const [tHeader, tPaymentDetails] = useTranslationWithPrefix([
    'checkout:header',
    'checkout:payment-details',
  ]);
  const [state] = useActor(paymentDetailsService);

  return (
    <>
      <Heading textType="header4" as="h1">
        {tHeader('payment-details')}
      </Heading>
      {state.matches('error') && (
        <S.Alert kind="danger">{tPaymentDetails('error-generic')}</S.Alert>
      )}
      <Card>
        <Card.Body>
          <CreditCardDetails
            countryCode={countryCode}
            onSuccess={onSuccess}
            uiPosition={PAGE.checkout}
            accountId={accountId}
          />
        </Card.Body>
      </Card>
    </>
  );
}
